import Decimal from "decimal.js";

export const SATS_PER_BTC = new Decimal("1e8");

export function convertSatsToUsd(
	satsPrice: number | string | null | undefined,
	btcUsdPrice: number | null | undefined,
): number | null {
	if (satsPrice === null || satsPrice === undefined) return null;
	if (!btcUsdPrice || btcUsdPrice <= 0) return null;

	try {
		const usd = new Decimal(satsPrice).div(SATS_PER_BTC).mul(btcUsdPrice);

		if (!usd.isFinite() || usd.lte(0)) return null;

		return Number(usd.toFixed(8));
	} catch {
		return null;
	}
}

export function convertUsdToSats(
	usdPrice: number | string | null | undefined,
	btcUsdPrice: number | null | undefined,
): number | null {
	if (usdPrice === null || usdPrice === undefined) return null;
	if (!btcUsdPrice || btcUsdPrice <= 0) return null;

	try {
		const sats = new Decimal(usdPrice).div(btcUsdPrice).mul(SATS_PER_BTC);

		if (!sats.isFinite() || sats.lte(0)) return null;

		return Number(sats.toFixed(3));
	} catch {
		return null;
	}
}
